export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo12-5f52efb5774d86765baac137714e1336.jpg";